import Button from "@material-ui/core/Button";
import AssignVariantDialog from "@saleor/components/AssignVariantDialog";
import { DEFAULT_INITIAL_SEARCH_DATA, PAGINATE_BY } from "@saleor/config";
import { configurationMenuUrl } from "@saleor/configuration";
import useBulkActions from "@saleor/hooks/useBulkActions";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
// import usePaginator from "@saleor/hooks/usePaginator";
import { createPaginationState } from "@saleor/hooks/usePaginator";
// import { maybe } from "@saleor/misc"
import { productVariantEditUrl } from "@saleor/products/urls";
import useProductVariantSearch from "@saleor/searches/useProductVariantSearch";
import SpecialOfferDetails, {
  SpecialOfferDetailsPageTab,
  SpecialOfferFormData
} from "@saleor/specialOffer/components/SpecialOfferDetails";
import {
  useRedemptionCataloguesAddMutation,
  useRedemptionCataloguesRemoveMutation,
  useRedemptionCreateDefaultMutation,
  useRedemptionReorderVariants,
  useRedemptionUpdateMutation,
  useRedemptionVariantUpdateMutation
} from "@saleor/specialOffer/mutations";
import { useRedemptionQuery } from "@saleor/specialOffer/queries";
import {
  SpecialOfferDialog,
  specialOfferUrl,
  SpecialOfferUrlQueryParams
} from "@saleor/specialOffer/urls";
import { ReorderEvent } from "@saleor/types";
import createDialogActionHandlers from "@saleor/utils/handlers/dialogActionHandlers";
import { move } from "@saleor/utils/lists";
import { mapEdgesToItems } from "@saleor/utils/maps";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
export interface SpecialOfferProps {
  params: SpecialOfferUrlQueryParams;
}
const SpecialOffer: React.FC<SpecialOfferProps> = ({ params }) => {
  const { data, loading, refetch } = useRedemptionQuery({});
  const navigate = useNavigator();
  const intl = useIntl();
  const notify = useNotifier();
  const id = data?.redemption?.id;
  // const paginate = usePaginator();
  const paginationState = createPaginationState(PAGINATE_BY, params);
  const { isSelected, listElements, reset, toggle, toggleAll } = useBulkActions(
    params.ids
  );
  const [defaultCreate] = useRedemptionCreateDefaultMutation({
    onCompleted: data => {
      if (data.redemptionCreateDefault.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Default Popup Created"
          })
        });
        refetch();
      }
    }
  });

  const [openModal, closeModal] = createDialogActionHandlers<
    SpecialOfferDialog,
    SpecialOfferUrlQueryParams
  >(navigate, params => specialOfferUrl(params), params);

  // const tabPageInfo =
  //   params.activeTab ===
  //   SpecialOfferDetailsPageTab.variants
  //     ? maybe(() => data?.redemption.redemptionVariants.pageInfo)
  //     : maybe(() => data?.redemption.redemptionVariants.pageInfo)

  // const {
  //     loadNextPage,
  //     loadPreviousPage,
  //     pageInfo
  // } = paginate(
  //     tabPageInfo,
  //     paginationState,
  //     params
  // );

  const [redemptionUpdate, redemptionUpdateOpts] = useRedemptionUpdateMutation({
    onCompleted: data => {
      if (data.redemptionUpdate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "General Information Update Success"
          })
        });
        refetch();
      }
    }
  });

  const [
    redemptionVariantUpdate,
    redemptionVariantUpdateOpts
  ] = useRedemptionVariantUpdateMutation({
    onCompleted: data => {
      if (data.redemptionVariantUpdate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Redemption Variant Update Success"
          })
        });
        refetch();
      }
    }
  });

  const handleSubmit = async (data: SpecialOfferFormData) => {
    const result = await redemptionUpdate({
      variables: {
        id,
        input: {
          name: data.name,
          description: data.description,
          minOrderAmount: data.minOrderAmount,
          enable: data.enable,
          maxRedemptionAmount: data.maxRedemptionAmount,
          signText: data.signText
        }
      }
    });
    const result2 = await redemptionVariantUpdate({
      variables: {
        redemptionId: id,
        variants: data.redemptionVariants
      }
    });
    return (
      result.data.redemptionUpdate.errors ||
      result2.data.redemptionVariantUpdate.errors
    );
  };

  const changeTab = (tab: SpecialOfferDetailsPageTab) => {
    reset();
    navigate(
      specialOfferUrl({
        activeTab: tab
      })
    );
  };

  const [redemptionCataloguesRemove] = useRedemptionCataloguesRemoveMutation({
    onCompleted: data => {
      if (data.redemptionCataloguesRemove.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Remove Redemption Variant Success"
          })
        });
        refetch();
      }
    }
  });

  const handleVariantsUnassign = (ids: string[]) =>
    redemptionCataloguesRemove({
      variables: {
        ...paginationState,
        id,
        input: {
          variants: ids
        }
      }
    });

  const {
    loadMore: loadMoreProductVariants,
    search: searchProductVariants,
    result: searchProductVariantsOpts
  } = useProductVariantSearch({
    variables: DEFAULT_INITIAL_SEARCH_DATA
  });

  const [
    redemptionCataloguesAdd,
    redemptionCataloguesAddOpts
  ] = useRedemptionCataloguesAddMutation({
    onCompleted: data => {
      if (data.redemptionCataloguesAdd.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Remove Redemption Variant Success"
          })
        });
        refetch();
        closeModal();
      }
    }
  });
  const [redemptionReorderVariants] = useRedemptionReorderVariants({
    onCompleted: data => {
      if (data.redemptionReorderVariants.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Reorder Redemption Variant Success"
          })
        });
        refetch();
      }
    }
  });
  const handleVariantReorder = ({ newIndex, oldIndex }: ReorderEvent) =>
    redemptionReorderVariants({
      optimisticResponse: {
        redemptionReorderVariants: {
          __typename: "RedemptionReorderVariants",
          redemption: {
            ...data.redemption,
            redemptionVariants: move(
              data.redemption.redemptionVariants[oldIndex],
              data.redemption.redemptionVariants,
              (a, b) => a.id === b.id,
              newIndex
            )
          },
          errors: []
        }
      },
      variables: {
        redemptionId: id,
        move: {
          redemptionVariantId: data.redemption.redemptionVariants[oldIndex].id,
          sortOrder: newIndex - oldIndex
        }
      }
    });

  return (
    <>
      <SpecialOfferDetails
        specialOffer={data?.redemption}
        onVariantReorder={handleVariantReorder}
        defaultCreate={() => defaultCreate({})}
        disabled={loading}
        onNextPage={null}
        onPreviousPage={null}
        toggle={toggle}
        toggleAll={toggleAll}
        isChecked={isSelected}
        selected={listElements.length}
        onSubmit={handleSubmit}
        onTabClick={changeTab}
        activeTab={params.activeTab}
        onBack={() => navigate(configurationMenuUrl)}
        saveButtonBarState={
          redemptionUpdateOpts.status || redemptionVariantUpdateOpts.status
        }
        variantListToolbar={
          <Button
            color="primary"
            onClick={() =>
              openModal("unassign-variant", {
                ids: listElements
              })
            }
          >
            <FormattedMessage
              defaultMessage="Unassign"
              description="unassign product sku from specialOffer, button"
              id="specialOfferDetailsUnassignVariant"
            />
          </Button>
        }
        onVariantAssign={() => openModal("assign-variant")}
        onVariantUnassign={variantId => handleVariantsUnassign([variantId])}
        onVariantClick={(productId, variantId) => () =>
          navigate(productVariantEditUrl(productId, variantId))}
      />
      <AssignVariantDialog
        confirmButtonState={redemptionCataloguesAddOpts.status}
        hasMore={searchProductVariantsOpts.data?.search?.pageInfo.hasNextPage}
        open={params.action === "assign-variant"}
        onFetch={searchProductVariants}
        onFetchMore={loadMoreProductVariants}
        loading={searchProductVariantsOpts.loading}
        onClose={closeModal}
        onSubmit={variants =>
          redemptionCataloguesAdd({
            variables: {
              ...paginationState,
              id,
              input: {
                variants: variants.map(variant => variant.id)
              }
            }
          })
        }
        variants={mapEdgesToItems(
          searchProductVariantsOpts?.data?.search
        )?.filter(suggestedVariant => suggestedVariant.id)}
      />
    </>
  );
};
export default SpecialOffer;
